import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthContext } from '@/context/AuthProvider';
import { CognitoGroup } from '@/models/User';

export const ProtectedRoute: FC = () => {
  const { user } = useAuthContext();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Gate advisors who haven't completed onboarding
  const isOnboardingRoute = location.pathname === '/onboarding';
  if (user.roles.includes(CognitoGroup.Advisor) && !user.isProfileComplete && !isOnboardingRoute) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
};
